export const printCharSizeArray = Array.from(Array(66).keys());

export const POS_PRINT_FONT_FAMILY = 'Roboto, Arial, sans-serif';
export const POS_PRINT_58MM_FONT_SIZE = '18px';
export const POS_PRINT_80MM_FONT_WEIGHT = 500;
export const POS_PRINT_58MM_FONT_WEIGHT = 700;
export const POS_PRINT_BOLD_FONT_WEIGHT = 700;

export const POS_PRINT_RENDERING_STYLES = {
  WebkitFontSmoothing: 'none',
  MozOsxFontSmoothing: 'grayscale',
  textRendering: 'geometricPrecision',
  imageRendering: 'pixelated',
} as const;

export const POS_PRINT_RENDERING_CSS =
  '-webkit-font-smoothing:none;-moz-osx-font-smoothing:grayscale;text-rendering:geometricPrecision;image-rendering:pixelated;';
